<template>
  <div>
    <ul>
      <li v-for="origin in origins">
        <div v-on:click="setOrigin(origin)">
          <img v-bind:src="origin.img">
          <div>{{ origin.name }}</div>
        </div>
      </li>
    </ul>
    <div class="box">
      <div>...or vote for your city to be the next origin.</div>
      <form>
        <input placeholder="Your home city"/>
        <button type="submit">Vote</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'origins',
  computed: mapState({
    origins: state => state.origins
  }),
  methods: {
    ...mapActions([
      'setOrigin'
    ])
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
li {
  display: inline-block;
  min-width: 160px;
  width: 33.3333333%;
}
li > div {
  margin: 3px;
  box-shadow: 1px 1px 1px #939393;
  background: white;
  cursor: pointer;
}
.box {
  margin: 3px;
  /*box-shadow: 1px 1px 0px #939393;*/
  /*background: white;*/
  padding: 3px 7px;
  border-radius: 2px;
  margin-top: 11px;
  font-size: 14px;
  text-align: left;
}
li > div:hover {
  box-shadow: 1px 1px 1px #444;
}
li > div > img {
  width: 100%;
}
li > div > div {
  text-align: left;
  padding: 7px 14px;
}
form {
  margin-top: 3px;
  display: flex;
  height: 30px;
  max-width: 280px;
  justify-content: space-between;
}
input {
  /*display: inline-block;*/
  border: 1px solid #939393;
  padding: 5px 5px 3px;
  border-radius: 2px;
  flex-grow: 1;
  margin-right: 5px;
  align-items: center;
  /*width:205px;*/
}
input:focus {
  border: 1px solid #36b8d4;
}
button {
  font-size: 14px;
  width: 70px;
  padding: 6px 13px;
  color: white;
  border-radius: 3px;
  background-color: #62c7dd;
  border: 1px solid #36b8d4;
}
button:hover {
  box-shadow: 0px 0px 1px #848484;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Origins.vue?142af06a